<template>
  <div class="limit-modal flex-y-center flex-col">
    <iconpark-icon name="close" class="icon-close" @click="onClose"> </iconpark-icon>
    <iconpark-icon name="Popupiconwarn" class="icon-warning mb-[10px]"></iconpark-icon>
    <div class="title">无法加购言币</div>
    <div class="sub">您已达到团队入门版账号加购上限，请联系我们升级企业版账号</div>
    <div class="operation mt-[40px] flex gap-[16px]">
      <a-button @click="onClose">取消</a-button>
      <a-button type="primary" @click="handleContact"> 联系我们 </a-button>
    </div>
  </div>
</template>

<script lang="ts" setup>
// import { PositionCode } from '~/api/module/analysisCenter';
import { PositionCode } from '@youyan/common';
import { showDynamicContact } from '~/hooks/useModal/modals/contact';
const props = defineProps<{
  onClose: () => void;
}>();

const handleContact = () => {
  props.onClose();
  showDynamicContact(PositionCode['有言官网权益管理加购言币']);
};
</script>

<style lang="scss" scoped>
.list {
  width: 300px;
  height: 90px;
  background: var(--back-2);
  border-radius: 8px;
  padding: 18px 20px;
  margin-top: 20px;
  > .t {
    font-weight: 500;
    font-size: 14px;
    color: var(--text-1);
    line-height: 20px;
  }
}
.title {
  font-size: 16px;
  color: var(--text-1);
  line-height: 22px;
  margin-bottom: 10px;
  font-weight: 600;
}
.sub {
  width: 282px;
  text-align: center;
  font-size: 13px;
  line-height: 20px;
  color: var(--text-1-70);
}
.icon-close {
  position: absolute;
  opacity: 0.6;
  font-size: 16px;
  right: 16px;
  top: 16px;
}
.icon-warning {
  font-size: 48px;
}
.limit-modal {
  display: flex;
  justify-content: center;
  width: 420px;
  height: 380px;
  background: #ffffff;
  border-radius: 8px;
}
</style>
